import type { ReactNode } from 'react';
import styled from 'styled-components';

/** Owrapowanie pod kolumnę tabeli (container query dla max-width chipów). */
export const AreaChipsWrap = styled.div`
  container-type: inline-size;
  display: flex;
  flex-flow: row wrap;
  align-content: flex-start;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 6px 8px;
  min-width: 12rem;
  max-width: min(720px, 100%);
`;

export const AreaChip = styled.span`
  box-sizing: border-box;
  flex: 0 0 auto;
  min-width: 0;
  width: max-content;
  /*
   * Without a query container, percentage max-width on flex children can resolve against a wide ancestor;
   * the 100cqi cap limits chip width to AreaChipsWrap (see container-type on the wrap).
   */
  max-width: 100%;

  @supports (width: 1cqi) {
    max-width: 100cqi;
  }

  padding: 5px 10px;
  border-radius: 999px;
  font-size: 12px;
  line-height: 1.35;
  white-space: normal;
  overflow-wrap: break-word;
  background-color: ${({ theme }) => theme.palette.neutral.veryLight};
  color: ${({ theme }) => theme.palette.text.primary};
  border: 1px solid ${({ theme }) => theme.palette.neutral.lightGrey};
  box-shadow: 0 1px 3px -1px ${({ theme }) => theme.palette.neutral.medium};
`;

export interface AreaPathChipDescriptor {
  key: string;
  label: string;
}

interface Props {
  chips: AreaPathChipDescriptor[];
  emptyLabel?: ReactNode;
}

/** Ścieżki obszarów w komórkach tabel — osobne „pigułki”, jak w RolesAndFunctionsTable. */
export function AreaPathChips({ chips, emptyLabel = '—' }: Props) {
  const filtered = chips.filter((c) => Boolean(c.label?.trim()));
  if (filtered.length === 0) {
    return <>{emptyLabel}</>;
  }

  return (
    <AreaChipsWrap>
      {filtered.map((c) => (
        <AreaChip key={c.key}>{c.label}</AreaChip>
      ))}
    </AreaChipsWrap>
  );
}
